'use client';

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from 'motion/react';
import { Button, Modal } from '~/components/primitives';
import React, { type ComponentProps, type ReactNode, useState } from 'react';
import type { Transition, Variants } from 'motion/react';
import { cx } from 'class-variance-authority';
import ModalCloseButton from '~/components/primitives/Modal/ModalCloseButton';
const SlideUpWithButton: React.FC<{
  children: ReactNode | ReactNode[];
  label: string;
  iconBefore?: ComponentProps<typeof Button>['iconBefore'];
  iconAfter?: ComponentProps<typeof Button>['iconAfter'];
  defaultValue?: boolean;
  className?: string;
}> = props => {
  const $ = _c(26);
  const [open, setOpen] = useState(props.defaultValue ?? false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      closed: {
        y: "100%"
      },
      open: {
        y: "0%"
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const VARIANTS = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      duration: 0.3,
      ease: "easeInOut"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const TRANSITION = t1;
  let t2;
  if ($[2] !== open) {
    t2 = open && <Modal.Background key="modal-background" onClick={() => setOpen(false)} className="backdrop-blur-xs inset-0 z-2 bg-blue-900/20" />;
    $[2] = open;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = open ? "open" : "closed";
  let t4;
  if ($[4] !== props.className) {
    t4 = cx("fixed bottom-0 left-0 right-0 z-modals overflow-hidden rounded-t-4xl border border-blue-100 bg-white shadow-lg shadow-black/30", props.className);
    $[4] = props.className;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ModalCloseButton onClick={() => setOpen(false)} className="top-5! right-5" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== props.children || $[8] !== t3 || $[9] !== t4) {
    t6 = <motion.aside key="modal-content" variants={VARIANTS} initial="closed" exit="closed" animate={t3} transition={TRANSITION} className={t4}>{t5}{props.children}</motion.aside>;
    $[7] = props.children;
    $[8] = t3;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = !open ? "open" : "closed";
  let t8;
  if ($[11] !== props.className) {
    t8 = cx("fixed bottom-0 left-0 right-0 z-modals rounded-t-4xl border border-blue-100 bg-white p-5 shadow-lg shadow-black/30", props.className);
    $[11] = props.className;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setOpen(true);
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = props.label ?? "";
  let t11;
  if ($[14] !== props.iconAfter || $[15] !== props.iconBefore || $[16] !== t10) {
    t11 = <Button onClick={t9} iconBefore={props.iconBefore} iconAfter={props.iconAfter} variant="tertiary" size="lg" className="w-full">{t10}</Button>;
    $[14] = props.iconAfter;
    $[15] = props.iconBefore;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t7 || $[20] !== t8) {
    t12 = <motion.aside key="button-content" variants={VARIANTS} initial="closed" exit="closed" animate={t7} transition={TRANSITION} className={t8}>{t11}</motion.aside>;
    $[18] = t11;
    $[19] = t7;
    $[20] = t8;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t2 || $[24] !== t6) {
    t13 = <AnimatePresence initial={false}>{t2}{t6}{t12}</AnimatePresence>;
    $[22] = t12;
    $[23] = t2;
    $[24] = t6;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
};
export default SlideUpWithButton;